import { ITokensPostResponse, Route } from "@edgetier/watchtower-types";
import { axios } from "utilities/axios";
import { setAccessToken } from "utilities/access-token";

/**
 * Get a new token. The refresh token is stored in a cookie and can be used to generate a new access token.
 */
export const refreshToken = async () => {
    const response = await axios.post<ITokensPostResponse>(Route.TokensRefresh);
    const { accessToken } = response.data;
    setAccessToken(accessToken);
    return accessToken;
};
